<template>
	<div class="voucher-attachment">
		<div class="att-head">
			<span class="att-title">附件（{{list.length}}）</span>
			<Button size="s" color="primary" icon="h-icon-upload" v-if="!readonly && (voucherId || tempId)" :loading="uploading" @click="doUpload">
				<input ref="file" type="file" style="display:none" @change="fileChange($event)">
				上传附件
			</Button>
		</div>
		<div class="att-empty" v-if="!list.length">暂无附件</div>
		<ul class="att-list" v-else>
			<li v-for="att in list" :key="att.id">
				<i class="fa" :class="iconClass(att.contentType)"></i>
				<a class="att-name" :href="downloadUrl(att.id)" target="_blank" :title="att.originalName">{{att.originalName}}</a>
				<span class="att-meta">{{formatSize(att.fileSize)}}<template v-if="att.createDate"> · {{att.createDate}}</template></span>
				<i class="h-icon-close att-del" v-if="!readonly" v-tooltip content="删除" @click="remove(att)"></i>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: "VoucherAttachment",
		props: {
			voucherId: [Number, String],
			tempId: String,
			readonly: {type: Boolean, default: false}
		},
		data() {
			return {
				list: [],
				uploading: false
			}
		},
		watch: {
			voucherId() {
				this.load();
			},
			tempId() {
				this.load();
			}
		},
		mounted() {
			this.load();
		},
		methods: {
			load() {
				if (this.voucherId) {
					this.$api.voucher.attachments(this.voucherId).then(({data}) => {
						this.list = data || [];
					});
					return;
				}
				if (this.tempId) {
					this.$api.voucher.attachmentsTemp(this.tempId).then(({data}) => {
						this.list = data || [];
					});
					return;
				}
				this.list = [];
			},
			doUpload() {
				this.$refs.file.click();
			},
			fileChange(e) {
				const file = e.target.files && e.target.files[0];
				if (!file) {
					return;
				}
				let formData = new FormData();
				if (this.voucherId) {
					formData.append('voucherId', this.voucherId);
				} else if (this.tempId) {
					formData.append('tempId', this.tempId);
				}
				formData.append('file', file);
				this.uploading = true;
				this.$api.voucher.uploadAttachment(formData).then(() => {
					this.$Message("亲，附件上传成功！");
					this.load();
					this.$emit('changed');
				}).finally(() => {
					this.uploading = false;
					e.target.value = '';
				});
			},
			remove(att) {
				this.$Confirm("亲，确认删除该附件吗？").then(() => {
					this.$api.voucher.deleteAttachment(att.id).then(() => {
						this.$Message("亲，附件已删除！");
						this.load();
						this.$emit('changed');
					});
				});
			},
			downloadUrl(id) {
				return `/api/voucher/attachment/download?id=${id}`;
			},
			formatSize(size) {
				if (size === null || size === undefined) {
					return '';
				}
				if (size < 1024) {
					return size + 'B';
				}
				if (size < 1024 * 1024) {
					return (size / 1024).toFixed(1) + 'KB';
				}
				return (size / 1024 / 1024).toFixed(2) + 'MB';
			},
			iconClass(type) {
				if (!type) {
					return 'fa-file-o';
				}
				if (type.indexOf('image/') === 0) {
					return 'fa-file-image-o';
				}
				if (type === 'application/pdf') {
					return 'fa-file-pdf-o';
				}
				if (type.indexOf('word') >= 0 || type.indexOf('officedocument.wordprocessingml') >= 0) {
					return 'fa-file-word-o';
				}
				if (type.indexOf('excel') >= 0 || type.indexOf('officedocument.spreadsheetml') >= 0) {
					return 'fa-file-excel-o';
				}
				if (type.indexOf('text/') === 0) {
					return 'fa-file-text-o';
				}
				return 'fa-file-o';
			}
		}
	}
</script>

<style lang='less' scoped>
	.voucher-attachment {
		border: 1px solid @border-color;
		border-radius: @border-radius;
		padding: 10px;
		background: #fff;

		.att-head {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: 8px;

			.att-title {
				font-weight: bold;
				color: @dark3-color;
			}
		}

		.att-empty {
			color: @gray2-color;
			padding: 10px 0;
			text-align: center;
			font-size: 13px;
		}

		.att-list {
			list-style: none;
			margin: 0;
			padding: 0;

			li {
				display: flex;
				align-items: center;
				padding: 6px 4px;
				border-bottom: 1px dashed @border-color;

				&:last-child {
					border-bottom: none;
				}

				.fa {
					color: @primary-color;
					margin-right: 8px;
					font-size: 16px;
				}

				.att-name {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					color: @dark2-color;
					text-decoration: none;

					&:hover {
						color: @primary-color;
					}
				}

				.att-meta {
					color: @gray2-color;
					font-size: 12px;
					margin: 0 10px;
					white-space: nowrap;
				}

				.att-del {
					color: @gray2-color;
					cursor: pointer;

					&:hover {
						color: @red-color;
					}
				}
			}
		}
	}
</style>
